module.exports = __webpack_public_path__ + "static/media/post_3300.343ecf83.glb";